import { render, staticRenderFns } from "./PaketMembershipDetail.vue?vue&type=template&id=703d8fd6"
import script from "./PaketMembershipDetail.vue?vue&type=script&lang=js"
export * from "./PaketMembershipDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports